import script from "./PrivateAllProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateAllProducts.vue?vue&type=script&setup=true&lang=js"

import "./PrivateAllProducts.vue?vue&type=style&index=0&id=384f1bc7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384f1bc7"]])

export default __exports__